import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import patientAgreements from '@/constants/patient-agreements'
import InfoSection from '@/components/ui/sections/InfoSection'
import RadioGroupInput from '@/components/ui/inputs/RadioGroupInput'
import ErrorMessage from '@/components/formik/messages/ErrorMessage'

import { PatientProfileFormData } from '../model/usePatientProfileForm'

export function ConsentSection() {
  useLingui()
  const rhForm = useFormContext<PatientProfileFormData>()

  const agreementOptions = useMemo(
    () =>
      patientAgreements.map((agreement) => ({
        label: {
          resident_patient: t`The patient the resident`,
          legal_representative: t`The legal representative`,
          confidence_person: t`The person of confidence`,
        }[agreement],
        value: agreement,
      })),
    []
  )

  return (
    <InfoSection label={t`Patient Agreement`}>
      <Controller
        control={rhForm.control}
        name="agreement"
        render={({ field, fieldState: { error } }) => (
          <RadioGroupInput
            onBlur={field.onBlur}
            onChange={field.onChange}
            error={!!error}
            helperText={!!error && <ErrorMessage error={error.message} />}
            fullWidth
            options={agreementOptions}
            value={field.value}
            variant="contained"
          />
        )}
      />
    </InfoSection>
  )
}
